<template>
    <div
        :class="{
            deposit: true,
            'padded-page': true,
            under: reviewData?.total_deposits > 0 && reviewData?.total_deposits < 1000,
            over: reviewData?.total_deposits >= 1000,
        }"
        ref="screenWrapper"
    >
        <template v-if="reviewData?.total_deposits === 0">
            <div class="mb-5 text-lg text-yInRev-blue font-satoshi_r">
                <p class="font-bold mb-3">You didn’t deposit any funds in 2025</p>
                <p>
                    Give it some love with a deposit!
                    <br /><br />
                    Don't worry, it won't bite. Your wallet's feeling a bit lonely.
                </p>
            </div>
        </template>
        <template v-else-if="reviewData?.total_deposits < 1000">
            <div>
                <p class="text-lg text-yInRev-blue font-satoshi_r">Your 2025 deposits were under</p>
                <p class="text-4xl text-yInRev-blue font-satoshi_b my-2">₦1,000</p>
                <p class="text-lg text-yInRev-blue font-satoshi_r">
                    Think you can 1000X your total deposits next time? We dare you. Let's see what you're made of.
                </p>
            </div>
        </template>
        <template v-else>
            <div class="mb-5">
                <p class="text-lg text-yInRev-blue font-satoshi_r">Total Amount Deposited</p>
                <p class="text-4xl text-yInRev-blue font-satoshi_b">
                    <CountUpNumber :endVal="reviewData?.total_deposits ?? 0" currency="₦" />
                </p>
            </div>
            <div class="border border-border-blue py-4 px-8 rounded-3xl" v-if="reviewData?.total_deposits > 1000">
                <p class="text-sm text-yIborder-yInRev-blue">Average Amount</p>
                <p class="text-2xl my-1 text-yInRev-blue font-satoshi_b">{{ $format.renderCurrency(reviewData?.average_amount_deposited) }}</p>
                <p v-if="!!reviewData?.top_depositor_name" class="text-sm text-yInRev-blue">
                    <span class="text-yInRev-green font-semibold">{{ reviewData?.top_depositor_name }}</span>
                    sent money to your wallet the most in 2025 with a total of
                    <span class="text-yInRev-green font-semibold">{{ $format.renderCurrency(reviewData?.top_depositor_amount) }}</span>
                </p>
            </div>
        </template>
    </div>
</template>

<script>
import CountUpNumber from "./CountUp.vue";

export default {
    components: {
        CountUpNumber,
    },

    props: {
        reviewData: Object,
    },

    mounted() {
        const screenWrapper = this.$refs.screenWrapper;
        const hammer = new Hammer(screenWrapper);

        hammer.on("tap", () => {
            if (this.currentScreen === 0) return;
            this.$emit("goForward");
        });
    },
};
</script>

<style scoped>
.deposit {
    padding: 16px;
    background-color: #eff1f3;
    min-height: 100vh;

    background-image: url("../../assets/images/year-in-review/deposit.svg");
    background-size: 70% 60%;
    background-repeat: no-repeat;
    background-position: bottom center;
}

.over {
    background-image: url("../../assets/images/year-in-review/deposit-over.svg");
    background-size: 80% 60%;
}

.under {
    background-image: url("../../assets/images/year-in-review/deposit-under.svg");
    background-size: 70% 60%;
}

@media (max-height: 750px) {
    .deposit {
        background-size: 40% auto !important;
    }
}
</style>
